import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { bool, array, object } from 'prop-types';
import { domains } from '../../../services/ApiService';
import { resetDomain } from '../../../actions/domains';
import { DomainFormView } from '../index';

class DomainForm extends Component {
  static propTypes = {
    types: array.isRequired,
    offers: array.isRequired,
    offer: object,
    loading: bool,
    isEdit: bool,
  };

  static defaultProps = {
    loading: false,
    offers: [],
    types: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      domain: {
        id: 0,
        domain: '',
        type: 'tracking',
        offerId: 0,
        tdsId: 0,
        landings: [],
        prelanders: [],
        title: '',
      },
      errors: {},
      modal: false,
      message: '',
    };
  }

  componentWillUnmount() {
    this.props.resetDomain();
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const prevType = this.state.domain.type;
    const nextType = nextState.domain.type;
    if (prevType !== 'click' && nextType === 'click') {
      this.props.history.push('/tools/flows/create', { click: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.domain).length > 0) {
      const { id = 0, domain, landingId, offerId, tdsId, type, title } = nextProps.domain;

      if (nextProps.domain && nextProps.domain.id !== this.state.domain.id) {
        this.setState(
          () => ({
            domain: {
              id,
              domain,
              type,
              offerId,
              tdsId,
              title,
              landings: type === 'landing' ? [landingId] : [],
              prelanders: type === 'prelander' ? [landingId] : [],
            },
          }),
          () => {
            if (offerId) {
              this.props.onOfferChange(offerId);
            }
          },
        );
      }
    }
  }

  handleChange = ({ target }) => {
    this.setState(prevState => ({
      domain: {
        ...prevState.domain,
        [target.name]: target.value,
      },
    }));
  };

  toggleModal = (e, message = '') => {
    this.setState(prevState => ({ modal: !prevState.modal, message }));
  };

  handleTypeChange = selected => {
    if (selected !== null) {
      const { value: type } = selected;

      this.setState(prevState => ({
        domain: {
          ...prevState.domain,
          type,
        },
        errors: {},
      }));
    }
  };

  handleDomainChange = (domain = '') => {
    this.setState(prevState => ({
      domain: {
        ...prevState.domain,
        domain,
      },
    }));
  };

  handleOfferChange = selected => {
    if (selected !== null) {
      const { value: offerId } = selected;

      this.setState(
        prevState => ({
          domain: {
            ...prevState.domain,
            landings: [],
            prelanders: [],
            offerId,
          },
          errors: {
            ...prevState.errors,
            offer: undefined,
          },
        }),
        () => {
          this.props.onOfferChange(offerId);
        },
      );
    }
  };

  handleLandingsChange = (id = 0) => {
    this.setState(prevState => ({
      domain: {
        ...prevState.domain,
        landings: [id],
      },
      errors: {
        ...prevState.errors,
        landings: undefined,
      },
    }));
  };

  handlePrelandersChange = (id = 0) => {
    this.setState(prevState => ({
      domain: {
        ...prevState.domain,
        prelanders: [id],
      },
      errors: {
        ...prevState.errors,
        prelanders: undefined,
      },
    }));
  };

  handleTDSChange = selected => {
    if (selected !== null) {
      const { value: tdsId } = selected;

      this.setState(prevState => ({
        domain: {
          ...prevState.domain,
          tdsId,
        },
        errors: {
          ...prevState.errors,
          tds: undefined,
        },
      }));
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    const { domain } = this.state;
    const errors = this.validate(domain);

    if (Object.keys(errors).length === 0) {
      this.props.onSubmit(domain);
    } else {
      this.setState(() => ({ errors }));
    }
  };

  validate = domain => {
    const errors = {};

    if (domain.type !== 'tracking' && domain.type !== 'tds' && !domain.offerId) {
      errors.offer = (
        <FormattedMessage id="flow.errors.no-offer" defaultMessage="Please select the offer" />
      );

      return errors;
    }

    if (domain.type === 'landing' && domain.type !== 'tds' && domain.landings.length === 0) {
      errors.landings = (
        <FormattedMessage
          id="domain.errors.no-landings"
          defaultMessage="Please select a landing page"
        />
      );
    }

    if (domain.type === 'prelander' && domain.type !== 'tds' && domain.prelanders.length === 0) {
      errors.prelanders = (
        <FormattedMessage
          id="domain.errors.no-prelanders"
          defaultMessage="Please select a prelander page"
        />
      );
    }
    if (domain.type === 'tds' && !domain.tdsId) {
      errors.tds = (
        <FormattedMessage id="domain.errors.no-tds" defaultMessage="Please select a the TDS flow" />
      );
    }

    if (domain.type === 'tds' && !domain.title) {
      errors.title = (
        <FormattedMessage id="domain.errors.no-title" defaultMessage="Please enter the title" />
      );
    }

    return errors;
  };

  getTypes = () => {
    const { types } = this.props;
    return types.map(type => ({
      id: type.key,
      title: type.title,
    }));
  };

  getParkingType = () => {
    const { type } = this.state.domain;
    const { types } = this.props;
    return types.find(pType => pType.key === type);
  };

  getOffersWithNoReplics = () => {
    const { offers, replicaOffersIds } = this.props;
    return offers.filter(offer => !replicaOffersIds.includes(offer.id));
  };

  render() {
    return (
      <DomainFormView
        stateData={this.state}
        propsData={this.props}
        handleSubmit={this.handleSubmit}
        handleDomainChange={this.handleDomainChange}
        getTypes={this.getTypes}
        handleTypeChange={this.handleTypeChange}
        getOffersWithNoReplics={this.getOffersWithNoReplics}
        handleOfferChange={this.handleOfferChange}
        handleChange={this.handleChange}
        handleTDSChange={this.handleTDSChange}
        getParkingType={this.getParkingType}
        handleLandingsChange={this.handleLandingsChange}
        handlePrelandersChange={this.handlePrelandersChange}
        toggleModal={this.toggleModal}
        replicaOffersIds={this.props.replicaOffersIds}
      />
    );
  }
}

const mapStateToProps = state => ({
  offers: state.webmaster.offers,
  offer: state.domains.offer,
  domain: state.domains.selected,
  types: state.app.globalSettings.parking,
  tdsStreams: _.filter(state.streams.streams, ({ site_id, offer_id }) => !site_id && !offer_id),
  profile: state.webmaster.profile,
  replicaOffersIds: state.domains.replicaOffersIds,
});

const mapDispatchToProps = dispatch => ({
  resetDomain: () => dispatch(resetDomain()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(DomainForm));
